module.exports = __webpack_public_path__ + "img/ju-jutsu-pass-267x360.5ab5a3c2.jpg";